export const environment = {
    production: true,
    baseHref: '/SanRafael',
    apiBase: 'https://squall/SanRafael',
    debug: true,
};
